import * as axios from "axios";
import CONFIG from "../../config";
import { getAuthHeader } from "../../utils";
import { Link, NavLink, BrowserRouter, useHistory } from "react-router-dom";
import { token } from "./AuthAction";

// Generate token
// export const getLogin = (model) => {
//     // const model={"id":"-1"}
//     const url = `${CONFIG.BASE_URL}/login`;
//     return axios.post(url, model)
//         .then((response) => {
//           localStorage.setItem("token",response.data.access_token)

//         });
// }

//get state
export const getLogin = (model) => {
  console.log(model);
  const url = `${CONFIG.BASE_URL}/user/login.json`;
  return axios.post(url, model).then((response) => {
    if (response.data.status) {
      //alert(response.data.roles[0].role_name);
      localStorage.setItem("status", response.data.status);
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("username", response.data.username);
      localStorage.setItem("roleid", response.data.roleid);
      localStorage.setItem("userrole", response.data.userrole);
      localStorage.setItem("email", response.data.email);
      localStorage.setItem("message", response.data.message);
    }
    return response.data;
  });
};

export const getSignup = (model) => {
  console.log(model);
  const url = `${CONFIG.BASE_URL}/signup`;
  return axios.post(url, model).then((response) => {
    return response.data;
  });
};

export const getLogout = (props) => {
  localStorage.removeItem("token");
  localStorage.removeItem("status");
  localStorage.removeItem("username");
  localStorage.removeItem("roleid");
  localStorage.removeItem("userrole");
  localStorage.removeItem("email");
  localStorage.removeItem("message");
  // props.history.push("/");
  window.location.reload();
};

export const username = () => {
  return localStorage.getItem("username");
};

export const email = () => {
  return localStorage.getItem("email");
};

export const roleid = () => {
  return localStorage.getItem("roleid");
};

export const role = () => {
  return localStorage.getItem("userrole");
};

// export const urlAccess  = () => {{
//     var auth = JSON.parse(localStorage.getItem('token'))
//     if(auth){
//       history.goBack()
//     }else{
//       props.history.push("/");
//     }
// }

// //get state map details
// export const getStateMapDetails = (model) => {
//   const url = `${CONFIG.BASE_URL}/govtinit/1/api/getmapdetails`;
//   return axios.post(url, model, getAuthHeader())
//       .then((response) => {
//           return response.data;
//       });
// }

// //get all ministry
// export const selectAllMinistry = (model) => {
//   const url = `${CONFIG.BASE_URL}/master/1/api/getallministry`;
//   return axios.post(url, model, getAuthHeader())
//       .then((response) => {
//           return response.data;
//       });
// }

// //get all department
// export const selectAllDepartment = (model) => {
//   const url = `${CONFIG.BASE_URL}/govtinit/1/api/getalldepartment`;
//   return axios.post(url, model, getAuthHeader())
//       .then((response) => {
//           return response.data;
//       });
// }

// //get all Central Gov Details
// export const getCentralGovDetails = (model) => {
//   const url = `${CONFIG.BASE_URL}/govtinit/1/api/getsearchcentrelgovdetails`;
//   return axios.post(url, model, getAuthHeader())
//       .then((response) => {
//           return response.data;
//       });
// }

// //get single central Gov Details
// export const getSingleCentralGovDetails = (model) => {
//   const url = `${CONFIG.BASE_URL}/govtinit/1/api/getsinglecentrelgovdetails`;
//   return axios.post(url, model, getAuthHeader())
//       .then((response) => {
//           return response.data;
//       });
// }

// //get single central Gov Details
// export const getFilterDepartment = (model) => {
//     const url = `${CONFIG.BASE_URL}/govtinit/1/api/selectcentraldepartment`;
//     return axios.post(url, model, getAuthHeader())
//         .then((response) => {
//             return response.data;
//         });
//   }

export const addCandidate = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/addcandidate`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const addCandidateImage = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/addcandidateimage`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const selectedJobCandidatesList = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/candidatejobselectedlist`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const selectedDriveCandidatesList = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/candidatedriveselectedlist`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const allCandidatesList = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/all-candidates`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const candidateBasicDetailUpdate = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/addcandidateprofile`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const candidateSkillUpdate = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/addcandidateskill`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const candidateTrainingUpdate = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/addcandidatetraining`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const candidateProjectUpdate = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/addcandidateproject`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const candidateQualificationUpdate = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/addcandidatequlification`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const candidatePreferredLocationUpdate = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/addcandidatepreferredlocation`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const candidatesDetails = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/candidate-mapping`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
export const candidatesAppliedDetails = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/candidate-applied-mapping`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const singleCandidatesDetails = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/getcandidatedetail`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const addSingelCandidate = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/addsingelcandidate`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const actionAppliedCandidateList = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/status-candidate-list`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const actionUploadResume = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/uploadresume`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const actionGetResume = (model) => {
  const url = `${CONFIG.BASE_URL}/candidate/getresume`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
